import { withIcon } from "../Icon"

export const IconAccount = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.217 17.878a6.656 6.656 0 0 0-5.317-2.645 6.655 6.655 0 0 0-5.317 2.645m0 0A8 8 0 1 1 17.216 5.923 8 8 0 0 1 6.583 17.878ZM14.567 9.9a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0Z"/>',
)
